export default {"src":"/_next/static/media/VolDeMouettesCommunautes.ad318461.svg","height":435,"width":1031};